var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKazakhstan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 12.1305H5.21738C5.21738 13.067 6.03305 13.8261 6.96947 13.8261H6.91303C6.91303 14.7626 7.67217 15.5218 8.60869 15.5218C8.60869 16.4583 9.36783 17.2174 10.3043 17.2174H13.6957C14.6322 17.2174 15.3913 16.4583 15.3913 15.5218C16.3278 15.5218 17.087 14.7626 17.087 13.8261H17.0305C17.9669 13.8261 18.7826 13.067 18.7826 12.1305Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 9.91302C16.6957 12.5063 14.5933 14.6087 12 14.6087C9.40664 14.6087 7.30434 12.5063 7.30434 9.91302",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5866 9.91302L14.1211 10.6024L14.9015 12.0218L13.3101 11.7173L13.1085 13.325L12 12.1425L10.8915 13.325L10.6899 11.7173L9.09849 12.0217L9.87886 10.6024L8.41336 9.91302L9.87891 9.22368L9.09849 7.80435L10.6898 8.10875L10.8915 6.50113L12 7.68355L13.1085 6.50113L13.3101 8.10875L14.9016 7.80435L14.1211 9.22372L15.5866 9.91302Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKazakhstan);
export default __webpack_public_path__ + "static/media/kazakhstan.f341fee68059882b150152626da3ec4b.svg";
export { ForwardRef as ReactComponent };